import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// // // LIST ALL SUBMISSIONS FROM JOBS
export const submissionList = params => Http.get(`/salary-submissions${serialize(params)}`)
// // // LIST SUBMISSIONS FROM ID
export const submissionByID = (params = '') => Http.get(`/salary-submissions/${params}`)
// // // POST NEW SUBMISSION
export const newSubmission = (params = '') => Http.post('/salary-submissions', params)
// // // UPDATE SUBMISSION
export const updateSubmission = (params = '') => Http.put(`/salary-submissions/${params.id}`, params)
// // // DELETE SUBMISSION
export const submissionDestroy = (params = '') => Http.delete(`/salary-submissions/${params.id}`)
